const chats = {
  state: {},
  mutations: {},
  actions: {},
  getters: {},
};

export default chats;
